import { InventoryArticle } from 'shared'
import { create } from 'zustand'

export interface FetchedStockInterface {
  stock: InventoryArticle[]
  sealedStock: InventoryArticle[]
  fetchedAt: string
  /**
   * Timestamp of the last full fetch from the DB.
   * If older than 3 days, StockPricingPresenter forces a fetchStock instead
   * of starting the diff polling.
   */
  lastFetchedFromDb?: string
}

export interface StockStoreState {
  activeStockType: string
  setActiveStockType: (newActiveStockType: string) => void
  refreshedStock: boolean
  setRefreshedStock: (newRefreshedStock: boolean) => void
  fetchedStock: FetchedStockInterface
  setFetchedStock: (
    newStock: FetchedStockInterface | ((arg: FetchedStockInterface) => FetchedStockInterface)
  ) => void
  stockLock: boolean
  setStockLock: (newStockLock: boolean) => void
}

export const useStockStore = create<StockStoreState>()((set) => ({
  activeStockType: 'singles',
  setActiveStockType: (newActiveStockType) =>
    set((s) =>
      s.activeStockType === newActiveStockType ? s : { activeStockType: newActiveStockType }
    ),

  refreshedStock: false,
  setRefreshedStock: (newRefreshedStock) =>
    set((s) =>
      s.refreshedStock === newRefreshedStock ? s : { refreshedStock: newRefreshedStock }
    ),

  fetchedStock: { stock: [], sealedStock: [], fetchedAt: '' },
  setFetchedStock: (newStock) =>
    set((state) => ({
      fetchedStock: typeof newStock === 'function' ? newStock(state.fetchedStock) : newStock,
    })),
  stockLock: false,
  setStockLock: (newStockLock: boolean) => set({ stockLock: newStockLock }),
}))
